//constants
import { GenericReferralConfig } from '@playback-rewards/shared-libraries'
import { AxiosError, AxiosResponse } from 'axios'
import QueryKeys from 'constants/queryKeys'
import toast from 'react-hot-toast'
import { useQuery } from 'react-query'
//services
import { getReferralConfig } from 'services/referalService'

const useQueryGetReferralConfig = () => {
  const { data, isLoading } = useQuery<AxiosResponse<GenericReferralConfig, Error>>(
    QueryKeys.GET_REFERRAL_CONFIG,
    getReferralConfig,
    {
      onError: (error) => {
        toast.error(
          ((error as AxiosError)?.response?.data as Error).message || 'Something went wrong!'
        )
      },
    }
  )

  return {
    isLoadingReferralConfig: isLoading,
    referralConfigData: data?.data,
  }
}

export default useQueryGetReferralConfig
